<div class="layout" *ngIf="dataReady">
  <div class="logo">
    <img src="assets/images/w4-cre-logo.png" />
  </div>
  <div class="form-layout">
    <router-outlet></router-outlet>
  </div>
  <div class="returnBtn">
    <button
      (click)="redirect()"
      label="{{ redirectButtonText }}"
      *ngIf="showLogoutButton"
      pButton
      type="button"
    ></button>
  </div>
  <div class="footer">
    <hr />
    <p>
      ©{{ year }} C.R. England, 4701 W 2100 S, Salt Lake City, UT 84120, United States. All Rights
      Reserved.
    </p>
  </div>
</div>
<p-dialog
  [blockScroll]="true"
  [modal]="true"
  [positionLeft]="40"
  [showHeader]="false"
  styleClass="modal-dialog"
  [(visible)]="confirmReturnDialogVisible"
>
  <div class="modal-dialog__header" fxFlex>Confirmation</div>
  <div fxFlex></div>
  <div class="modal-dialog__description" fxFlex>Thank you for Completing your W-4.</div>
  <div fxFlex>
    <button
      class="modal-dialog__confirm-btn"
      (click)="hideConfirmReturnDialog()"
      fxLayoutAlign="center center"
      fxFlex
      pButton
      type="button"
    >
      Continue to Portal
    </button>
  </div>
</p-dialog>
